import { clientTestimonials as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'Client Testimonials',
  testimonials: [
    {
      title: 'Super knowledgeable and on top of things!',
      text: 'minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
      author: 'Andrew Watchloz',
    },
    {
      title: 'Best team ever!',
      text: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae ',
      author: 'Jillian Stonebrook',
    },
    {
      title: 'Understood my family needs',
      text: ' Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? ',
      author: 'Patty Arevelo',
    },
  ],
};

export default fakeProps(schema, TestData);
